module.exports = __webpack_public_path__ + "img/error.24b0323c.svg";